import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Subsidio {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root'
})
export class SubsidioService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // Lista todos os Subsidios
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: Subsidio[] }>(
      `${this.path}`,
      params ? new HttpParams({ fromObject: params }) : this.params
    ).pipe(
      map(response => response)
    );
  }

  // Busca Subsidio por ID
  public show(id: string): Observable<any> {
    return this.apiService.get<{ object: Subsidio }>(`${this.path}/${id}`).pipe(
      map(response => response)
    );
  }

  // Cria novo Subsidio
  public store(subsidio: Subsidio): Observable<any> {
    return this.apiService
      .post<{ object: Subsidio }>(`${this.path}`, subsidio)
      .pipe(map(response => response));
  }

  // Cria múltiplos Subsidios (range)
  public storeRange(subsidios: Subsidio[]): Observable<any> {
    return this.apiService
      .post<{ data: Subsidio[] }>(`${this.path}/range`, subsidios)
      .pipe(map(response => response));
  }

  // Actualiza Subsidio
  public update(subsidio: Subsidio): Observable<any> {
    return this.apiService
      .put<{ object: Subsidio }>(`${this.path}`, subsidio)
      .pipe(map(response => response));
  }

  // Remove Subsidio
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/${id}`);
  }
}
